import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Autocomplete } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const ScrollContainer = styled.div<{ height?: string }>`
    position: relative;
    height: ${({ height }) => (height ? height : "100%")};
    overflow: auto;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${carbon[50]};
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background-color: ${carbon[100]};
    }

    scrollbar-width: thin;
    scrollbar-color: ${carbon[100]} transparent;
`;

ScrollContainer.displayName = "ScrollContainer";

export const AutocompleteStyled = styled(Autocomplete)`
    width: 100%;

    .AutoCompleteContainer {
        z-index: 5;
    }
`;

AutocompleteStyled.displayName = "AutocompleteStyled";

export const PlaceholderText = styled.span`
    ${setFontVariant("input2", carbon[200])};
    margin-left: 36px;
`;

PlaceholderText.displayName = "PlaceholderText";
